<template>
    <div>
        <preloader :background="false" :display="loading" v-if="loading" />
        <webhooks-form-template :logs="logs" :form="form" :rules="rules" @submit="submit" v-else>
            <template slot="endpoint">
                <el-form-item prop="endpoint" :error="errors.endpoint">
                    <span class="gray-100" slot="label">
                        {{ $l10n.__('Endpoint personnalisé') }}
                    </span>
                    <div class="flex-row ai-center">
                        <i class="icon-link mr-2"></i>
                        <el-input v-model="form.endpoint"></el-input>
                    </div>
                </el-form-item>
                <el-form-item prop="sign_key" :error="errors.sign_key">
                    <span class="gray-100" slot="label">
                        {{ $l10n.__('Clé de signature') }}
                    </span>
                    <div class="flex-row ai-center">
                        <el-input v-model="form.sign_key"></el-input>
                    </div>
                </el-form-item>
                <div class="webhook-http__config__actions">
                    <el-checkbox v-model="form.is_enabled">{{
                        $l10n.__('Webhook actif ?')
                    }}</el-checkbox>
                    <el-checkbox v-model="form.object_in_payload">{{
                        $l10n.__("Retourne l'objet dans le payload ?")
                    }}</el-checkbox>

                    <label class="webhook-http__config__actions__select--label">
                        {{ $l10n.__('Content-type') }}
                        <el-select v-model="form.json_content_type">
                            <el-option :value="false" label="application/x-www-form-urlencoded" />
                            <el-option :value="true" label="application/json" />
                        </el-select>
                    </label>
                </div>
            </template>
            <template slot="tagEvents" slot-scope="scopeEvents">
                {{ activeEvents(scopeEvents.currentLog.id) }} /
                {{ getAllEventsForParentLog(scopeEvents.currentLog.id).length }}
            </template>
            <!-- Logs events -->
            <div slot="events" slot-scope="scope">
                <el-table :data="getEventsConfigByLog(scope.log.id)" class="b-1" stripe>
                    <el-table-column prop="label" width="390">
                        <span slot="header" slot-scope="scopeHeader" class="regular">
                            {{ getTableTitleByLog(scope.log) }}
                        </span>
                    </el-table-column>
                    <el-table-column label="Webhook Event" prop="id">
                        <div slot-scope="scopeId" class="flex-level">
                            <p>{{ getWebhookEventName(scopeId.row.id) }}</p>
                        </div>
                    </el-table-column>
                    <el-table-column
                        :label="$t.__('developerPage.WebhooksForms.Webhooks.activated')"
                        width="65"
                    >
                        <el-switch
                            slot-scope="scopeEnabled"
                            @input="(e) => handleSwitch(e, scopeEnabled.row)"
                            :value="scopeEnabled.row.is_enabled"
                        ></el-switch>
                    </el-table-column>
                </el-table>

                <!-- Child events to main Log -->
                <div v-for="childLog of getLogsChildByLog(scope.log.id)" :key="childLog.id">
                    <el-table :data="getEventsConfigByLog(childLog.id)" class="b-1" stripe>
                        <el-table-column prop="label" width="390">
                            <span slot="header" slot-scope="scopeHeader" class="regular">
                                {{ getTableTitleByLog(childLog) }}
                            </span>
                        </el-table-column>
                        <el-table-column label="Webhook Event" prop="id">
                            <div slot-scope="scopeId" class="flex-level">
                                <p>{{ getWebhookEventName(scopeId.row.id) }}</p>
                            </div>
                        </el-table-column>
                        <el-table-column
                            :label="$t.__('developerPage.WebhooksForms.Webhooks.activated')"
                            width="65"
                        >
                            <el-switch
                                slot-scope="scopeEnabled"
                                @input="(e) => handleSwitch(e, scopeEnabled.row)"
                                :value="scopeEnabled.row.is_enabled"
                            ></el-switch>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </webhooks-form-template>
    </div>
</template>
<script>
import WebhooksFormTemplate from 'vcomponents/developerPage/WebhooksForms/WebhooksFormTemplate.vue';
import WebhooksMixins from 'vcomponents/developerPage/WebhooksForms/WebhooksMixins';
export default {
    components: {
        WebhooksFormTemplate,
    },
    mixins: [WebhooksMixins],
};
</script>

<style lang="scss">
.webhook-http__config__actions {
    display: flex;
    align-items: center;

    &__select--label {
        display: flex;
        flex-direction: column;
    }
}
</style>
